import { FC } from 'react';

import RhfRadioGroup from 'components/RadioGroup/RhfRadioGroup/RhfRadioGroup';
import { getSagittalImproveSubOptionsConfig } from 'containers/PendingPrescription/pendingPrescriptionConfig';
import { translate } from 'utils';
interface Props {
  fieldName: string;
  improvementType: string;
  isDisabled?: boolean;
}
const SagittalImproveSubOptions: FC<Props> = ({
  fieldName,
  isDisabled,
  improvementType
}) => {
  return (
    <div className='flex flex-col p-4'>
      {getSagittalImproveSubOptionsConfig(improvementType)?.map((subOption) => {
        const subOptionFieldName = `${fieldName}.${subOption.key}`;
        return (
          <div key={subOption.key}>
            <div className='flex flex-row space-x-4 items-center'>
              <div className='text-14px font-bold mt-2 '>
                {`${translate(subOption.name)}:`}
              </div>
              <RhfRadioGroup
                inputProps={{ disabled: isDisabled }}
                options={subOption.options}
                name={subOptionFieldName}
                className='flex flex-row space-x-16'
                radioClassName='border-RADIO_BORDER'
                radioItemFont='md:text-17px text-sm '
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default SagittalImproveSubOptions;
